export default "__VITE_ASSET__BRiaVfuP__"